import { render, staticRenderFns } from "./flip-quick-stats.vue?vue&type=template&id=4b9c8abb&scoped=true"
import script from "./flip-quick-stats.vue?vue&type=script&lang=js"
export * from "./flip-quick-stats.vue?vue&type=script&lang=js"
import style0 from "./flip-quick-stats.vue?vue&type=style&index=0&id=4b9c8abb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c8abb",
  null
  
)

export default component.exports